import { Component, OnInit } from '@angular/core';
import {CoefService} from '../../service/coef.service';

@Component({
  selector: 'app-door-right-d',
  templateUrl: './door-right-d.component.html',
  styleUrls: ['./door-right-d.component.scss']
})
export class DoorRightDComponent implements OnInit {

  constructor(public coef: CoefService) { }

  ngOnInit() {
  }

}
